<vdw-selection-list-container
  [containerTitle]="containerTitle"
  [selectListOptions]="selectListOptions"
  [maxHeight]="maxHeight"
  (selectListOptionsChanged)="onFilterOptionChanged($event)"
></vdw-selection-list-container>
